const IconPlayFull = ({ className }) => {
    return (
        <svg
            enableBackground='new 0 0 100 100'
            viewBox='0 0 100 100'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path d='m50 2.5c-26.125 0-47.5 21.375-47.5 47.5s21.375 47.5 47.5 47.5 47.5-21.375 47.5-47.5-21.375-47.5-47.5-47.5zm-9.5 64.5941772v-34.1883583c0-2.6430645 3.0826836-4.086916 5.1131439-2.3948669l20.5130157 17.0941811c1.4955902 1.2463264 1.4955902 3.5434074 0 4.7897339l-20.5130157 17.0941772c-2.0304603 1.6920547-5.1131439.2481995-5.1131439-2.394867z'></path>
        </svg>
    );
};

export default IconPlayFull;
